import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../navbar/navbar'; 
import { api } from '../../../services/api';
import {vhostV1, vhostV2} from '../../funcoes';
import BuscaVazaia from "../../components/buscavazia/buscaVazia";
import './tesouraria.css'
import customizeScrollbar from "customsb";
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toolbar } from '@mui/material';


function Tesouraria() {

  const [dataInicial,setDataInicial] = useState('');
  const [dataFinal,setDataFinal] = useState('');
  const [texto,setTexto] = useState('');
  const [busca,setBusca] = useState('');
  const [resultConta,setresultConta] = useState(0);
  const [tesouraria,setTesouraria] = useState([]);
  const [seq_banco, setSeqBanco] = useState(0);
  const [bancos, setBancos] = useState([]);
  const [contasOriginais, setContasOriginais] = useState([]);
  const [msgErro, setmsgErro] = useState('');
  const [erroValidacao, setErroValidacao] = useState(false);
  const [juros,setJuros] = useState(0);
  const [valor,setValor] = useState(0);
  const [multa,setMulta] = useState(0);
  const [desconto,setDesconto] = useState(0);
  const [valorPago,setValorPago] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [totalPagar,setTotalPagar] = useState(0);
  const [finalizadoraSelecionada, setFinalizadoraSelecionada] = useState(0);
  const [movSelecionado, setMovSelecionado] = useState(0);
  
  const [pessoas,setPessoas] = useState([])
  const [buscaPessoa,setBuscaPessoa] = useState('');
  const [resultPessoa,setResultPessoa] = useState(0);
  const [razao,setRazao] = useState('');
  const [responsavel,setResponsavel] = useState(0);
  
  const [vlrHistorico,setvlrHistorico] = useState(0);
  const [vlrSaldo,setvlrSaldo] = useState(0);
  const [tipoMovimento, setTipoMovimento] = useState([]);
  const [tesourariaFiltrada, setTesourariaFiltrada] = useState([]);
  const [sacado,setSacado] = useState(0);
  const [usaData,setUsaData] = useState(true);
  const [marcados,setMarcados] = useState([]);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [checkboxNome, setCheckboxNome] = useState(false);
  const [finalizadora, setFinalizadora] = useState([]);
  const [dataPagamento, setDataPagamento] = useState(new Date());
  const [tipoConta, setTipoConta] = useState('P');
  const [tipoMovFiltrado, setTipoMovFiltrado] = useState([]);
  
  let contasQuitar = [];
  let valorQuitar = 0;



 let config = {
   headers: {
     'Authorization': localStorage.getItem("token")
   }
 }

 let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }


useEffect(() => {

  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);

const parseDateFromDMY = (dateStr) => {
  if (!dateStr || dateStr.trim() === '') return null;
  const [day, month, year] = dateStr.split('/').map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

const parseDateFromISO = (dateStr) => {
  if (!dateStr || dateStr.trim() === '') return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

console.log(checkboxChecked);


const handleFilter = () => {
  
const startDateVencimento = parseDateFromISO(dataInicial);
const endDateVencimento = parseDateFromISO(dataFinal);


  
  console.log('Venc:' + endDateVencimento);
  

  const result = tesouraria.filter(conta => {
   
    const dueDate = parseDateFromDMY(conta.DATA_VENC);

    
    console.log('Item Dates: ', {
      dueDate  
    });

    if(checkboxChecked === false && checkboxNome === false){
      setTesouraria(contasOriginais);
      setmsgErro('selecione algum dos marcadores para filtrar por ele')
      setErroValidacao(true)
      return tesouraria
    } else if(checkboxChecked === true && checkboxNome === false){
      const dateFilter = (!startDateVencimento || (dueDate && dueDate >= startDateVencimento)) &&
      (!endDateVencimento || (dueDate && dueDate <= endDateVencimento));
      return dateFilter
    } else if(checkboxChecked === false && checkboxNome === true){
      const nameFilter = !responsavel || (conta.RESPONSAVEL && conta.RESPONSAVEL === Number(responsavel));
      return nameFilter
    } else {
      const dateFilter = (!startDateVencimento || (dueDate && dueDate >= startDateVencimento)) &&
      (!endDateVencimento || (dueDate && dueDate <= endDateVencimento));
      const nameFilter = !responsavel || (conta.RESPONSAVEL && conta.RESPONSAVEL === Number(responsavel));
      return dateFilter && nameFilter;
    }




    
   
   
      
      
      
    
  });
  console.log('Filtered Results:', result);
  setTesouraria(result);
  
};


  function limpaPesquisa() {
    setDataInicial('');
    setDataFinal('');
    setRazao('');
    setTesouraria(contasOriginais);
    setCheckboxChecked(false);
    setCheckboxNome(false);
  }


  // function listaContas(e) {
  //   e.preventDefault();

  //   api.post(vhostV1('webcash/tesouraria/listacontas'), {
  //     empresa: 0,
  //     tipo: "R",
  //     sacado: responsavel,
  //     datainicial: dataInicial,
  //     datafinal: dataFinal,
  //     loja: localStorage.getItem('loja')
  //   }, config)
  //   .then((response) => {
  //     const contasFiltradas = filtrarTesouraria(response.data.dados, dataInicial, dataFinal, razao);
  //     setTesouraria(contasFiltradas);
  //     setresultConta(response.data.result);
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
  // }



  useEffect(function(){
    api.post(vhostV1('webcash/contas'), {
        loja: localStorage.getItem('loja'),
        empresa: 0,
        busca: '',
        tipo: tipoConta,
        colaborador:0
      },config)
      .then(function (response) {
         setresultConta(response.data.result); 
         setTesouraria(response.data.dados); 
         setContasOriginais(response.data.dados)
         console.log(response.data.dados);
                   
        }                               
      )
      .catch(function (error) {
        console.log(error);
                
      });
  
      
  
  
      
  },[tipoConta])

function listaPessoa(e){
  e.preventDefault();
  api.post(vhostV1('webcash/cadastro'), {
      loja: localStorage.getItem('loja'),
      empresa: 0,
      tipo: "%",
      busca: buscaPessoa
    },config)
    .then(function (response) {
      setPessoas(response.data.dados);  
      setResultPessoa(response.data.result);
      console.log(response.data.dados);    
      
               
    })
    .catch(function (error) {
     
      console.log(error);

              
    });
  };


  useEffect(function(){
      
      api.get(vhostV1('webcash/finalizadoras/'), config)
        .then(function (response) {
            if (response && response.data && response.data.dados){
            setFinalizadora(response.data.dados); 
            console.log(response.data.dados)
            
            }       
        })
        .catch(function (error) {
          console.log(error);
                  
        });
  
        
    },[])


  useEffect(function(){
    api.post(vhostV1('webcash/banco'), {
        loja: localStorage.getItem('loja'),
        empresa: 1,
        busca: ''  
      },config)
      .then(function (response) {
        if(response && response.data && response.data.dados){
         setBancos(response.data.dados);
                 
        }}                               
      )
      .catch(function (error) {
        console.log(error);
                
      });
  },[])

  useEffect(function(){
    api.get(vhostV1('webcash/planoConta/tipos-movimento-bancario'),config)
      .then(function (response) {
        console.log(response);
        setTipoMovimento(response.data.dados);
        if(tipoConta === 'P'){
            const filtradas = tipoMovimento.filter((item) => item.TIPO === 'D');
           setTipoMovFiltrado(filtradas);
           console.log(filtradas);
           
        } else {
            const filtradas = tipoMovimento.filter((item) => item.TIPO === 'C');
           setTipoMovFiltrado(filtradas);
           console.log(filtradas);
        }
                                      
  })
      .catch(function (error) {
        console.log(error);
                
      });
  },[tipoConta])



  function pesquisaPessoa(e){
    console.log(e.substring(1,6));
    setResponsavel(e.substring(1,6));
    setRazao(e.substring(9,50));
    
  };


  function marcaLinha(e){
     console.log(e.target.checked); 
  };

  const handleCheckboxChange = (e, item) => {
    const isChecked = e.target.checked;
    let novosMarcados;

    if (isChecked) {
       
        novosMarcados = [...marcados, item];
        
        
    } else {
     
        novosMarcados = marcados.filter((marcado) => marcado.SEQ !== item.SEQ);
    }

    setMarcados(novosMarcados);
    console.log(marcados);
    

    // Atualiza os valores com base nos itens marcados
    atualizarTotais(novosMarcados);
};

const atualizarTotais = (marcados) => {
    const totalContas = marcados.reduce((acc, item) => acc + Number(item.VALOR), 0);
    const saldoPagar = marcados.reduce((acc, item) => acc + Number(item.TOTAL_PAGAR), 0);
    const valorPago = marcados.reduce((acc, item) => acc + Number(item.VALOR_PAGO), 0);
    const juros = marcados.reduce((acc, item) => acc + Number(item.JUROS), 0);
    const multa = marcados.reduce((acc, item) => acc + Number(item.MULTA), 0);

    setvlrHistorico(totalContas);
    setSubtotal(saldoPagar);
    setvlrSaldo(saldoPagar);
    setValor(totalContas);
    setTotalPagar(saldoPagar);
    setValorPago(valorPago);
    setJuros(juros);
    setMulta(multa);

};

function quitaContas(){

    const sJson = {
        contas: marcados.map((item) => item.SEQ),
        banco: seq_banco,
        finalizadora: finalizadoraSelecionada,
        tipoMovimento: movSelecionado,
        dataPagamento: dataPagamento,
        juros: juros,
        desconto: desconto,
        multa: multa,
        totalPagar: totalPagar    
    };

    console.log(sJson);

    api.post(vhostV1('webcash/tesouraria/contas'), sJson, config)
    .then(function (response) {
        console.log(response);
        
    }).catch(function (error) {
        console.log(error);
    });
}





function salvatpc(e){
 
    setTipoConta(e);
    localStorage.setItem("tipoconta", e)  

  }
 

  function converterData(dataISOString) {
    // Cria um objeto Date a partir da string ISO
    const data = new Date(dataISOString);
    
    // Extrai o ano, mês e dia
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Meses começam do 0 (Janeiro)
    const dia = String(data.getDate()).padStart(2, '0');

    // Retorna a data no formato 'YYYY-MM-DD'
    return `${ano}-${mes}-${dia}`;
}

const formatDateISOtoDMY = (isoDate) => {
    const date = new Date(isoDate); 
    
    if (isNaN(date)) return ''; 
    
    const day = date.getDate().toString().padStart(2, '0'); 
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear(); 
    
    return `${day}/${month}/${year}`; 
  }; 


   
   return <div>
   <Navbar />
   <Toolbar />
   <div className="container-fluid">
       <div className="row mb-4">
           <div className="col-lg-10 offset-lg-1">
               <h1 className="mb-4">Tesouraria</h1>

               <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            checked={checkboxChecked}
            onChange={(e) => setCheckboxChecked(e.target.checked)}
            id="flexCheckDefault"
          />
          <label
            className="form-check-label"
            htmlFor="flexCheckDefault"
          >
            Data Vencimento
          </label>
        </div>

        <div className="row mb-3 align-items-end">
          <div className="col-md-3 mb-2 mb-md-0">
            <input
              type="date"
              className="form-control"
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
            />
          </div>
          <div className="col-md-3 mb-2 mb-md-0">
            <input
              type="date"
              className="form-control"
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
            />
          </div>
          <div className="col-md-6 d-flex justify-content-end">

          <div class="custom-select-container me-2">
             <h5 className='me-2'>Tipo </h5>   
             
            
             <select id="inputUnidade" value={tipoConta} onChange={(e)=> salvatpc(e.target.value)} className="form-select custom-select " tabIndex="3" >
                <option value={'R'}>RECEBER</option>
                <option value={'P'}>PAGAR</option>                    
               </select>
          
            
           
           </div>

            <button
              onClick={handleFilter}
              className="btn btn-primary me-2"
              type="button"
            >
              <i className="fas fa-search"></i> Pesquisar
            </button>
            <button
              onClick={limpaPesquisa}
              className="btn btn-danger"
              type="button"
            >
              <i className="fas fa-trash"></i> Limpar
            </button>
          </div>
        </div>

               <div className="row mb-4">
                   <div className="col-lg-6">
                       <div className="input-group">
                       <input
                          className="form-check-input"
                          type="checkbox"
                          checked={checkboxNome}
                          onChange={(e) => setCheckboxNome(e.target.checked)}
                          id="flexCheckDefault"
                               />
                           <input
                               type="text"
                               placeholder="Pesquisar por nome"
                               value={razao}
                               onChange={(e) => setRazao(e.target.value)}
                               className="form-control"
                               disabled
                           />
                           <button
                               type="button"
                               className="btn btn-secondary"
                               data-bs-toggle="modal"
                               data-bs-target="#staticBackdrop"
                           >
                               Pesquisar
                           </button>
                       </div>

                       <div
                           className="modal fade"
                           id="staticBackdrop"
                           data-bs-backdrop="static"
                           data-bs-keyboard="false"
                           aria-labelledby="staticBackdropLabel"
                           aria-hidden="true"
                       >
                           <div className="modal-dialog modal-lg">
                               <div className="modal-content">
                                   <div className="modal-header">
                                       <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                           Pesquisa Cadastro
                                       </h1>
                                       <button
                                           type="button"
                                           className="btn-close"
                                           data-bs-dismiss="modal"
                                           aria-label="Close"
                                       ></button>
                                   </div>
                                   <div className="modal-body">
                                       <div className="input-group mb-3">
                                           <input
                                               type="text"
                                               className="form-control"
                                               placeholder="Digite sua pesquisa"
                                               value={buscaPessoa}
                                               onChange={(e) => setBuscaPessoa(e.target.value)}
                                               aria-describedby="button-addon2"
                                           />
                                           <button
                                               onClick={listaPessoa}
                                               className="btn btn-primary"
                                               type="button"
                                               id="button-addon2"
                                           >
                                               <i className="fas fa-search"></i> Pesquisar
                                           </button>
                                       </div>

                                       {resultPessoa === 1 ? (
                                           <table className="table table-hover table-striped">
                                               <thead>
                                                   <tr>
                                                       <th scope="col">Código</th>
                                                       <th scope="col">Razão</th>
                                                       <th scope="col">Ação</th>
                                                   </tr>
                                               </thead>
                                               <tbody className="table-group-divider">
                                                   {pessoas.map((pessoa) => (
                                                       <tr key={pessoa.COD_CADASTRO}>
                                                           <td>{pessoa.COD_CADASTRO}</td>
                                                           <td>{pessoa.RAZAO}</td>
                                                           <td>
                                                               <a
                                                                   href="#"
                                                                   onClick={() =>
                                                                       pesquisaPessoa(
                                                                           ('000000' + pessoa.COD_CADASTRO).slice(-6) +
                                                                               ' - ' +
                                                                               pessoa.RAZAO
                                                                       )
                                                                   }
                                                                   className="text-decoration-none"
                                                               >
                                                                   <i className="fas fa-edit icone-acao red" data-bs-dismiss="modal"></i>
                                                               </a>
                                                           </td>
                                                       </tr>
                                                   ))}
                                               </tbody>
                                           </table>
                                       ) : (
                                           <BuscaVazaia />
                                       )}
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>

                   <div className="col-lg-6 d-flex justify-content-end">
    <button
        type="button"
        className="btn btn-success"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
    >
        <i className="bi bi-coin"></i> Quitar Contas
    </button>

    <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Quitar Contas
                    </h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="modal-body">
                   
                    <div className="row mb-3">
                        <div className="col-12 col-md-6">
                            <label htmlFor="inputBanco" className="form-label">Banco</label>
                            <select
                                id="inputBanco"
                                value={seq_banco}
                                onChange={(e) => setSeqBanco(e.target.value)}
                                className="form-select"
                            >
                                {bancos.map((banco) => (
                                    <option key={banco.SEQ_BANCO} value={banco.SEQ_BANCO}>
                                        {banco.DESCRICAO}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="inputFinalizadora" className="form-label">Finalizadora</label>
                            <select onChange={e => setFinalizadoraSelecionada(e.target.value)} value={finalizadoraSelecionada} id="inputFinalizadora" className="form-select">
                              
                            <option value="">Selecione a forma de pagamento</option> 
                            {finalizadora.map((forma) => (
                            <option key={forma.COD_FINALIZADORA} value={forma.DESCRICAO}>
                              {forma.COD_FINALIZADORA} - {forma.DESCRICAO}
                             </option>
                           ))}
                            </select>
                        </div>
                    </div>

                   
                    <div className="row mb-3">
                        <div className="col-12 col-md-6">
                            <label htmlFor="tpMov" className="form-label">Tipo Movimento</label>
                        <select onChange={e => setMovSelecionado(e.target.value)} value={movSelecionado} name="tipoMovimento" id="tpMov" className="form-select">
                          <option value="">Selecione o tipo movimento</option> 
                          {tipoMovFiltrado.map((forma) => (
                            <option key={forma.SEQ_MOVIMENTO} value={forma.SEQ_MOVIMENTO}>
                             {forma.DESCRICAO}
                            </option>
                          ))}
                        </select>
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="inputDate" className="form-label">Data</label>
                            <input value={dataPagamento} onChange={e => setDataPagamento(e.target.value)} type="date" className="form-control" id="inputDate" />
                        </div>
                    </div>

                 
                    <div className="row mb-3">
                        <div className="col-12 col-md-6">
                            <label htmlFor="inputValor" className="form-label">Valor</label>
                            <input
                                type="text"
                                className="form-control"
                                id="inputValor"
                                value={valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                onChange={(e) => setValor(e.target.value)}
                                readOnly
                                placeholder="R$ 0,00"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="inputJuros" className="form-label">Juros</label>
                            <input
                                type="text"
                                className="form-control"
                                id="inputJuros"
                                value={juros.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                onChange={(e) => setJuros(e.target.value)}
                                placeholder="R$ 0,00"
                            />
                        </div>
                    </div>

                 
                    <div className="row mb-3">
                        <div className="col-12 col-md-4">
                            <label htmlFor="inputMulta" className="form-label">Multa</label>
                            <input
                                type="text"
                                className="form-control"
                                id="inputMulta"
                                value={multa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                onChange={(e) => setMulta(e.target.value)}
                                placeholder="R$ 0,00"
                            />
                        </div>
                        <div className="col-12 col-md-4">
                            <label htmlFor="inputDesconto" className="form-label">Desconto</label>
                            <input
                                type="text"
                                className="form-control"
                                id="inputDesconto"
                                value={desconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                onChange={(e) => setDesconto(e.target.value)}
                                placeholder="R$ 0,00"
                            />
                        </div>
                        <div className="col-12 col-md-4">
                            <label htmlFor="inputValorPago" className="form-label">Valor Pago</label>
                            <input
                                type="text"
                                className="form-control"
                                id="inputValorPago"
                                value={valorPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                onChange={(e) => setValorPago(e.target.value)}
                                placeholder="R$ 0,00"
                            />
                        </div>
                    </div>

                  

                    <div className="row mb-3">
                        <div className="col-12 col-md-6">
                        <label htmlFor="inputTotalPagar" className="form-label">Subtotal</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputTotalPagar"
                            readOnly
                            value={subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            onChange={(e) => setSubtotal(e.target.value)}
                            placeholder="R$ 0,00"
                        />
                        </div>

                        <div className="col-12 col-md-6">
                        <label htmlFor="inputPagamento" className="form-label">Total a Pagar</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputTotalPagar"
                            value={totalPagar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            onChange={(e) => setTotalPagar(e.target.value)}
                            placeholder="R$ 0,00"
                        />
                        </div>

                    </div>
                    <div className='d-flex justify-content-center'>
                        <button onClick={quitaContas} className="btn btn-success btn-lg">Receber</button>
                    </div>
                    <hr />
                    <div>
                        <h5 className='form-label'>Contas Selecionadas</h5>
                        <table className="table table-hover table-striped"> 
                            <thead>
                                <tr>
                                <th scope="col">Seq</th>
                                <th scope="col">Razão</th>
                                <th scope="col">Data Vencimento</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Subtotal</th>
                                </tr>
                            </thead>

                            <tbody className='table-group-divider'>
                                {marcados.map((item) => ( 
                                    <tr key={item.SEQ}>
                                        <td>{item.SEQ}</td>
                                        <td>{item.RAZAO}</td>
                                        <td>{formatDateISOtoDMY(item.DATA_VENC)}</td>
                                        <td>{Number(item.VALOR).toFixed(2)}</td>
                                        <td>{Number(item.TOTAL_PAGAR).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Fechar
                    </button>
                    <button onClick={quitaContas} type="button" className="btn btn-primary">
                        Finalizar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
               </div>

               {tesouraria.length > 0 ? (
                <table id="table-tes" className="table table-hover table-striped">
                    <thead>
                        <tr>
                            <th scope="col" width="5%">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={(e) => {
                                        const todosMarcados = e.target.checked;
                                        if (todosMarcados) {
                                            setMarcados(tesouraria);
                                            atualizarTotais(tesouraria);
                                        } else {
                                            setMarcados([]);
                                            atualizarTotais([]);
                                        }
                                    }}
                                />
                            </th>
                            <th scope="col">Seq.</th>
                            {/* <th scope="col">Empresa</th> */}
                            <th scope="col">Responsável</th>
                            <th scope="col">Razão</th>
                            <th scope="col">Data Emissão</th>
                            <th scope="col">Data Vencimento</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Juros</th>
                            <th scope="col">Multa</th>
                            <th scope="col">Valor Pago</th>
                            {/* <th scope="col">Desconto</th> */}
                            <th scope="col">Total Pagar</th>
                        </tr>
                    </thead>
                    <tbody className="table-group-divider">
                        {tesouraria.map((item) => (
                            <tr key={item.SEQ}>
                                <th scope="row">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={item.TOTAL_PAGAR}
                                        id={item.SEQ}
                                        onChange={(e) => handleCheckboxChange(e, item)}
                                        checked={marcados.some((marcado) => marcado.SEQ === item.SEQ)}
                                    />
                                </th>
                                <td>{item.SEQ}</td>
                                {/* <td>{item.EMPRESA}</td> */}
                                <td>{item.RESPONSAVEL}</td>
                                <td>{item.RAZAO}</td>
                                <td>{formatDateISOtoDMY(item.DATA_EMISSAO)}</td>
                                <td>{formatDateISOtoDMY(item.DATA_VENC)}</td>
                                <td>{Number(item.VALOR).toFixed(2)}</td>
                                <td>{Number(item.JUROS).toFixed(2)}</td>
                                <td>{Number(item.MULTA).toFixed(2)}</td>
                                <td>{Number(item.VALOR_PAGO).toFixed(2)}</td>
                                {/* <td>{Number(item.DESCONTO).toFixed(2)}</td> */}
                                {/* <td>{0.00.toFixed(2)}</td> */}
                                <td>{Number(item.TOTAL_PAGAR).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <table id="table-tesouraria" className="table table-hover table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Seq.</th>
                            <th scope="col">Empresa</th>
                            <th scope="col">Responsável</th>
                            <th scope="col">Razão</th>
                            <th scope="col">Data Emissão</th>
                            <th scope="col">Data Vencimento</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Juros</th>
                            <th scope="col">Multa</th>
                            <th scope="col">Valor Pago</th>
                            <th scope="col">Desconto</th>
                            <th scope="col">Total Pagar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="12" className="text-center">
                                Nenhum dado disponível
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}

            <div className="row mt-4">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label htmlFor="inputHistorico" className="form-label">Total Contas</label>
                        <input
                            type="text"
                            value={Number(vlrHistorico).toFixed(2)}
                            className="form-control"
                            id="inputHistorico"
                            readOnly
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <label htmlFor="inputSaldoPagar" className="form-label">Saldo Pagar</label>
                        <input
                            type="text"
                            value={Number(vlrSaldo).toFixed(2)}
                            className="form-control"
                            id="inputSaldoPagar"
                            readOnly
                        />
                    </div>
                </div>
            
               </div>
           </div>
       </div>
       
       {
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErroValidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }
   </div>
</div>
    
}


export default Tesouraria;